import { useUserCredentialsStore } from "@/stores";
import { TransactionTypes } from "@/stores/user-credentials";
import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

interface DecodedRedirectData {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  amount: string;
  buyOrSell: "buy" | "sell";
  productId: string;
  customerId: string;
  customerLeadId: string;
}

function decodeRedirectData(encodedData: string): DecodedRedirectData | null {
  try {
    const decodedString = decodeURIComponent(encodedData);
    const jsonString = atob(decodedString);
    console.log(jsonString);
    return JSON.parse(jsonString) as DecodedRedirectData;
  } catch (error) {
    console.error("Error decoding redirect data:", error);
    if (error instanceof URIError) {
      console.warn("Invalid URL encoding in redirect data");
    } else if (error instanceof SyntaxError) {
      console.warn("Invalid JSON format in redirect data");
    }
    return null;
  }
}

export function URLParameterHandler({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const updateProfile = useUserCredentialsStore((s) => s.updateProfile);

  useEffect(() => {
    const encryptedData = searchParams.get("data");
    if (encryptedData) {
      const decodedData = decodeRedirectData(encryptedData);
      console.log("Decoded data:", decodedData);
      if (decodedData) {
        updateProfile({
          customerLeadId: decodedData.customerLeadId,
          firstName: decodedData.firstName,
          lastName: decodedData.lastName,
          phoneNumber: decodedData.phone,
          initialMilesAmount: Number(decodedData.amount),
          transactionType: decodedData.buyOrSell as TransactionTypes,
          customerId: decodedData.customerId,
          productId: decodedData.productId,
          email: decodedData.email,
        });
      } else {
        console.warn("Failed to process URL parameters. Using default values.");
      }
    }
  }, [searchParams, location, updateProfile]);

  return <>{children}</>;
}
